export const formatPrice = price => {
    const format = formatMe =>
        formatMe.toLocaleString('sv', {
            symbol: ' kr',
            symbolPosition: 'end',
            decimal: ',',
            comma: '.'
        });
    return typeof price !== 'number'
        ? `${format(parseInt(price))} kr`
        : `${format(price)} kr`;
};

export const formatShippingPrice = (price, t) => {
    if (price === 0) {
        return t('myt_itemCard_free_Shipping');
    } else {
        return formatPrice(price);
    }
};
